// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../contact/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../contact/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shared-spinner{height:1.4285714rem;aspect-ratio:1;color:#b7b7ba}.shared-spinner.is-dark{color:#8c8c8e}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
